<template>
  <div
    class="aboutUs"
    :style="($env && $env.inMiniProgram) ? { paddingTop: (statusBarHeight + 60) + 'px' } : {}"
  >
    <!-- 微信小程序 web-view：左上角返回按钮（不影响 App 内嵌 H5） -->
    <button
      v-if="$env && $env.inMiniProgram"
      class="mp-back-btn-fixed-left"
      :style="{ top: (statusBarHeight + 12) + 'px' }"
      @click="goBackMiniProgram"
    >
      <i class="el-icon-arrow-left"></i>
    </button>
    <div class="main">
      <h2>关于我们</h2>
      <p>
        大救星-健康版是由江泰救援服务有限公司自主研发并运营，专注于各类人群身体健康的健康监测APP，能有效降低其在工作、生活中发生疾病风险。在传统医疗救援的基础上，为用户提供了涵盖体检报告解读、疾病预防、健康监测、一键救援、健康咨询等多项综合健康服务。
      </p>
      <p>
        基于移动互联网技术，大救星平台以健康监测设备和线上APP相结合，用健康预警的方式为用户降低健康风险，提供及时、高效的救援和救助服务，为用户带来全方位的安全保障。
      </p>
      <p>联系电话：010-68180898</p>
    </div>
    <div v-if="version" class="foot">版本号： {{ version }}</div>
    <div  class="foot">备案号：京ICP备2025140282号-4A</div>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';

export default {
  name: 'AboutUs',
  data() {
    return {
      version: '',
    }
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight'])
  },
  mounted() {
    window.getAppVersionNameResult = this.getAppVersionNameResult
    document.title = '关于我们'
    this.$nextTick(() => {
      this.getAppVersion()
    })
  },
  methods: {
    getAppVersionNameResult(version) {
      // 原生回调方法，接收版本号
      this.version = version
    },
    getAppVersion() {
      if (this.$env.inDjxApp){
            if (this.$env.inAndroid){
               try {
                JSInterface.getAppVersionName()
              } catch (error) {
                console.log(error)
              }
            }else if (this.$env.inIos) {
              try {
                // window.webkit.messageHandlers.saveUserInfo.getAppVersionName();
              } catch (error) {
                console.log(error)
              }
            }
          }
    },
 
    goBack() {
      window.location.href = "appdjxhealth://actionFinishWebview"
    },

    /**
     * 微信小程序环境返回上一页
     */
    goBackMiniProgram() {
      this.$router.go(-1);
    },
  },
}
</script>
<style lang="less" scoped>
// ::-webkit-scrollbar {
//   width: 0 !important;
//   height: 0;
// }
::-webkit-scrollbar-track {
  width: 0 !important;
  background-color: transparent !important; /* 设置滚动条追踪区的背景色为透明 */
}
@supports (
    (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top))
  )
  and (-webkit-overflow-scrolling: touch) {
  body {
    /* 适配齐刘海 */
    padding-top: 20px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    /* 适配底部小黑条 */
    padding-bottom: 0;
    padding-bottom: costant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.aboutUs {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;

  .mp-back-btn-fixed-left {
    position: fixed;
    left: 12px;
    z-index: 9999;
    width: 36px;
    height: 36px;
    border-radius: 18px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
  .main {
    width: 100%;
    flex: 1;
    height: auto;
    overflow-y: scroll;
    padding: 3.15vh 4vw;
    h2 {
      font-size: 4vw;
      text-align: center;
      margin-bottom: 2vw;
    }
    h3,
    p {
      font-size: 3.5vw;
      line-height: 4vh;
    }
  }
  .foot {
    text-align: center;
    color: #999;
    line-height: 6vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/aboutUs.vue